/** lrc-cart-gift-sync.js — Optimistic gifts, plan changes, and VIRTUAL shipment gifts (pass-based) */

/* =================== VIRTUAL SHIPMENT GIFTS (PASS-BASED) =================== */
(function () {
    // Only show virtual gifts when the rewards widget is in SUBS mode
    function isSubsRewardsMode() {
        const root = document.getElementById('lrc-rewards-root');
        return !!root && (root.getAttribute('data-lrc-mode') || '').trim() === 'subs';
    }

    // Read shipment packs emitted by Liquid in #lrc-shipment-products-json:
    // [{ id: <passNumber>, plan_name: "...", products:[{title,subtitle,image,url?}, ...] }]
    function readShipmentPacks() {
        try {
            const el = document.getElementById('lrc-shipment-products-json');
            if (!el) return [];
            const arr = JSON.parse(el.textContent || '[]') || [];
            // Normalize: strip empty product entries (all fields blank)
            arr.forEach(pack => {
                pack.products = Array.isArray(pack.products)
                    ? pack.products.filter(p => {
                        const t = (p.title || '').trim();
                        const s = (p.subtitle || '').trim();
                        const i = (p.image || '').trim();
                        return !!(t || s || i);
                    })
                    : [];
            });
            return arr;
        } catch { return []; }
    }

    // ---- LAZY packs cache (fixes "PACKS: []" on first subs add) ----
    let __PACKS_CACHE = null;
    function getPacks(force = false) {
        if (
            force ||
            !Array.isArray(__PACKS_CACHE) ||
            __PACKS_CACHE.length === 0
        ) {
            __PACKS_CACHE = readShipmentPacks();
        }
        return __PACKS_CACHE;
    }

    function readUnlockedPassCount() {
        const root = document.getElementById('lrc-rewards-root');
        if (!root) return 0;
        const n = parseInt(root.getAttribute('data-lrc-qty') || '0', 10);
        return Number.isFinite(n) ? n : 0;
    }

    function buildVirtualGift({ key, title, subtitle, image, url }) {
        const t = String(title || '').trim();
        const s = String(subtitle || '').trim();
        const img = String(image || '').trim();
        const url_v = String(url || '').trim() || '#';
        return `
      <div class="flex flex-col space-y-2 group relative"
           data-virtual-gift
           data-reward-pass="${key.pass}"
           data-virtual-key="${key.pass}:${key.idx}">
        <a href="${url_v}">
          ${img ? `<img src="${img}" loading="lazy" class="w-full h-32 object-contain">`
                : `<div class="w-full h-20 bg-white"></div>`}
        </a>
        ${s ? `<h6 class="font-base text-xs text-cyan-800 text-center">${s}</h6>` : ``}
        ${t ? `<h5 class="font-base text-sm text-cyan-800 font-[700] text-center leading-[16px] tracking-tight">
                <a href="${url_v}">${t}</a>
              </h5>` : ``}
      </div>`;
    }

    function gridEl() { return document.getElementById('lrc-free-gifts-grid'); }

    // Build HTML for all currently unlocked passes (SUBS mode only)
    function htmlForUnlocked() {
        if (!isSubsRewardsMode()) return '';
        const unlocked = readUnlockedPassCount();
        if (!unlocked) return '';

        let html = '';
        for (let pass = 1; pass <= unlocked; pass++) {
            const pack = getPacks().find(p => Number(p.id) === Number(pass));
            if (!pack || !Array.isArray(pack.products) || !pack.products.length) continue;
            pack.products.forEach((p, idx) => {
                html += buildVirtualGift({ key: { pass, idx }, ...p });
            });
        }
        return html;
    }

    function appendForPass(pass) {
        if (!isSubsRewardsMode()) return; // only in SUBS mode
        const grid = gridEl(); if (!grid) return;

        const pack = getPacks().find(p => Number(p.id) === Number(pass));
        if (!pack || !Array.isArray(pack.products) || !pack.products.length) return;

        removeForPass(pass);

        const frag = document.createDocumentFragment();
        pack.products.forEach((p, idx) => {
            const shell = document.createElement('div');
            shell.innerHTML = buildVirtualGift({ key: { pass, idx }, ...p });
            frag.appendChild(shell.firstElementChild);
        });
        grid.prepend(frag);
    }

    function removeForPass(pass) {
        const grid = gridEl(); if (!grid) return;
        grid.querySelectorAll(`[data-virtual-gift][data-reward-pass="${pass}"]`).forEach(n => n.remove());
    }

    function rebuildAll() {
        const grid = gridEl(); if (!grid) return;
        grid.querySelectorAll('[data-virtual-gift]').forEach(n => n.remove());
        if (!isSubsRewardsMode()) return; // nothing to show in ONE-TIME mode

        // ensure we read any newly-rendered packs before rebuilding
        getPacks(true);

        const unlocked = readUnlockedPassCount();
        // prepend in reverse so pass 1 stays before pass 2 in the final DOM order
        for (let pass = unlocked; pass >= 1; pass--) appendForPass(pass);
    }

    // expose API (plus a way to force-refresh packs if caller needs it)
    window.lrcVirtualGifts = {
        appendForPass,
        removeForPass,
        rebuildAll,
        htmlForUnlocked,
        __refreshPacks: () => getPacks(true)
    };

    // when the cart drawer swaps in new HTML (including the JSON tag), refresh packs
    document.addEventListener('lrc:drawer-updated', () => {
        getPacks(true); // keep cache fresh; caller may call rebuildAll elsewhere
    });
})();


// ---========= Unlocked tier % (from UI) with observer + cached value =======---
/* =========================================================
   Observe unlocked reward tier % from UI
   → cache it
   → automatically call refreshSubsLineCardsFromCache()
========================================================= */
(function () {
  const KEY = 'lrc-unlocked-tier-percent';

  function parsePercent(txt) {
    const m = String(txt || '').match(/(\d+)\s*%/i);
    if (!m) return 0;
    const n = parseInt(m[1], 10);
    return Number.isFinite(n) ? n : 0;
  }

  function readFromUI() {
    const els = Array.from(document.querySelectorAll('[data-subs-frequency-hint]'));
    let best = 0;

    els.forEach(el => {
      const pct = parsePercent(el.textContent);
      if (pct > best) best = pct;
    });

    return best;
  }

  function writeCache(n) {
    try { localStorage.setItem(KEY, String(n || 0)); } catch {}
  }

  function readCache() {
    try {
      const n = parseInt(localStorage.getItem(KEY) || '0', 10);
      return Number.isFinite(n) ? n : 0;
    } catch { return 0; }
  }

  // public getter
  window.lrcGetUnlockedTierPercent = function () {
    return readFromUI() || readCache();
  };

  let lastValue = 0;

  function syncIfChanged() {
    const pct = readFromUI();
    if (!pct) return;

    if (pct !== lastValue) {
      lastValue = pct;
      writeCache(pct);

      console.log('[LRC] unlocked tier updated →', pct);

      // 🔥 THIS IS WHAT YOU WANT:
      if (typeof window.lrcRefreshSubsFromLatestCart === 'function') {
        window.lrcRefreshSubsFromLatestCart();
      }
    }
  }

  function bootObserver() {
    const root =
      document.querySelector('[data-lrc-cart-panel]') ||
      document.querySelector('[data-lrc-cart-root]') ||
      document.body;

    if (!root) return;

    // run immediately
    syncIfChanged();

    // also after drawer updates
    document.addEventListener('lrc:drawer-updated', syncIfChanged);

    // observe DOM mutations
    const mo = new MutationObserver(() => {
      syncIfChanged();
    });

    mo.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootObserver);
  } else {
    bootObserver();
  }
})();


/* =================== MAIN: gifts/plan sync (existing behavior preserved) =================== */
(function () {
    const GIFT_TAG = '_lrcGift';
    const LS_PENDING = 'lrc-custom-pending-cart-ops';
    const LS_BASE_UNIT = 'lrc-custom-base-unit-prices';
    const LS_PASS_PLAN_MAP = 'lrc-custom-subs-discount-pass-map';
    const CART_CACHE_KEY = 'lrc-custom-get-cart';

    const readLS = (k, d) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch { return d; } };
    const writeLS = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch { } };

    const readPending = () => normalizePending(readLS(LS_PENDING, {}));
    const writePending = (o) => writeLS(LS_PENDING, normalizePending(o));
    const clearPending = () => writePending({ addGiftIds: [], removeGiftIds: [], planByVariantId: {} });

    function normalizePending(p) {
        const o = p && typeof p === 'object' ? p : {};
        if (!Array.isArray(o.addGiftIds)) o.addGiftIds = [];
        if (!Array.isArray(o.removeGiftIds)) o.removeGiftIds = [];
        if (!o.planByVariantId || typeof o.planByVariantId !== 'object') o.planByVariantId = {};
        o.addGiftIds = [...new Set(o.addGiftIds.map(Number).filter(Number.isFinite))];
        o.removeGiftIds = [...new Set(o.removeGiftIds.map(Number).filter(Number.isFinite))];
        return o;
    }
    // Read "real" gifts currently rendered in the grid (ignores virtuals)
    function getRenderedGiftIdsFromGrid() {
        try {
            const grid = document.getElementById('lrc-free-gifts-grid');
            if (!grid) return [];
            return Array.from(grid.querySelectorAll('[data-lrc-gift-vid]'))
                .map(el => Number(el.getAttribute('data-lrc-gift-vid')))
                .filter(Number.isFinite);
        } catch { return []; }
    }

    function readCacheLS() {
        try { const raw = localStorage.getItem(CART_CACHE_KEY); if (!raw) return null; const obj = JSON.parse(raw); return obj && obj.cart ? obj.cart : null; } catch { return null; }
    }
    async function getCartCached() {
        if (window.lrcGetCartCachedOrFetch) { try { return await window.lrcGetCartCachedOrFetch(false); } catch { } }
        const ls = readCacheLS(); if (ls) return ls;
        const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
        const cart = await r.json(); writeCartCached(cart); return cart;
    }

    function writeCartCached(cart) { if (window.lrcWriteCartCache) { try { window.lrcWriteCartCache(cart); return; } catch { } } writeLS(CART_CACHE_KEY, { t: Date.now(), cart }); }

    function loadGiftMetaMap() {
        const tag = document.getElementById('lrc-gift-meta'); if (!tag) return { by_variant: {}, by_handle: {} };
        try { return JSON.parse(tag.textContent || '{}'); } catch { return { by_variant: {}, by_handle: {} }; }
    }
    function giftMetaLookup(map, vid, handle) {
        const byV = map?.by_variant?.[String(vid)]; if (byV && (byV.title || byV.subtitle)) return byV;
        const byH = handle ? map?.by_handle?.[String(handle)] : null; return byH || null;
    }
    function extractHandle(p) {
        if (p?.handle) return String(p.handle);
        if (typeof p?.url === 'string') { const m = p.url.match(/\/products\/([^/?#]+)/i); if (m) return m[1]; }
        return '';
    }

    const parseEscapedJson = (attr) => { try { const t = document.createElement('textarea'); t.innerHTML = attr || '[]'; return JSON.parse(t.value || '[]'); } catch { return []; } };
    const parseThresholdsCsv = (csv) => (csv || '').split(',').map(s => parseInt(String(s).trim(), 10)).filter(n => Number.isFinite(n) && n >= 0).sort((a, b) => a - b);

    function readRewardsRoot() {
        const root = document.getElementById('lrc-rewards-root'); if (!root) return null;
        return {
            pass: parseInt(root.getAttribute('data-lrc-qty') || '0', 10) || 0,
            subQty: parseInt(root.getAttribute('data-lrc-subqty') || '0', 10) || 0,
            oneCents: parseInt(root.getAttribute('data-lrc-one-subtotal') || '0', 10) || 0,
            mode: (root.getAttribute('data-lrc-mode') || '').trim(),
            rewards: parseEscapedJson(root.getAttribute('data-lrc-rewards') || '[]'),
            oneThresholds: parseThresholdsCsv(root.getAttribute('data-lrc-one-thresholds') || ''),
            oneConfig: parseEscapedJson(root.getAttribute('data-lrc-one-config') || '[]'),
        };
    }

    function pickGiftImage(p) {
        const cands = [p?.image?.src, p?.image?.url, p?.image,
        p?.featured_image?.src, p?.featured_image?.url, p?.featured_image,
        p?.featured_media?.preview_image?.src,
        p?.selected_or_first_available_variant?.image?.src,
        p?.selected_or_first_available_variant?.featured_media?.preview_image?.src,
        Array.isArray(p?.images) ? p.images[0] : null,
        Array.isArray(p?.media) ? (p.media[0]?.src || p.media[0]?.preview_image?.src) : null];
        return (cands.find(Boolean) || '').toString();
    }
    const pickGiftTitle = (p) => (p?.title || p?.product_title || p?.variant_title || 'Gift').toString();
    const pickGiftUrl = (p) => (p?.url || '#').toString();

    function computeDesiredGiftsMap() {
        const rr = readRewardsRoot(); if (!rr) return { ids: [], infoByVariantId: {} };
        const metaMap = loadGiftMetaMap(); const infoByVariantId = {};
        const addGiftItems = (gift_items) => {
            if (!Array.isArray(gift_items)) return;
            gift_items.forEach(p => {
                const vid = Number(p?.selected_or_first_available_variant?.id ?? p?.variants?.[0]?.id ?? p?.id);
                if (!Number.isFinite(vid)) return;
                const handle = extractHandle(p);
                const meta = giftMetaLookup(metaMap, vid, handle);
                infoByVariantId[vid] = {
                    title: (meta?.title && String(meta.title).trim()) || pickGiftTitle(p),
                    subtitle: String(meta?.subtitle || '').trim(),
                    image: pickGiftImage(p),
                    url: pickGiftUrl(p)
                };
            });
        };

        if (rr.pass > 0) {
            for (let i = 1; i <= rr.pass; i++) {
                const r = rr.rewards.find(x => Number(x.id) === i);
                if (r?.gift_items) addGiftItems(r.gift_items);
            }
        }
        if (rr.subQty > 0 && rr.oneCents > 0 && rr.oneThresholds.length) {
            let onePass = 0;
            for (let i = 0; i < rr.oneThresholds.length; i++) { if (rr.oneCents >= rr.oneThresholds[i]) onePass++; else break; }
            for (let i = 1; i <= onePass; i++) {
                const cfg = rr.oneConfig.find(x => Number(x.id) === i);
                if (cfg?.gift_items) addGiftItems(cfg.gift_items);
            }
        }

        const ids = Object.keys(infoByVariantId).map(Number).filter(Number.isFinite);
        return { ids, infoByVariantId };
    }

    function formatMoney(c) { const n = Math.round(Number(c) || 0); try { if (window.Shopify?.formatMoney) return Shopify.formatMoney(n, Shopify.money_format || '${{amount}}'); } catch { } return '$' + (n / 100).toFixed(2); }

    /* ================== 1) Add this helper near refreshSubsLineCardsFromCache ================== */
    function buildVariantModeMap(cart) {
        const map = new Map();
        (cart?.items || []).forEach(li => {
            const vid = Number(li?.variant_id);
            if (!Number.isFinite(vid)) return;

            const rec = map.get(vid) || { hasSubs: false, hasOne: false, mixed: false };
            const isSubs = !!li?.selling_plan_allocation;
            if (isSubs) rec.hasSubs = true;
            else rec.hasOne = true;

            rec.mixed = rec.hasSubs && rec.hasOne;
            map.set(vid, rec);
        });
        return map;
    }

    function hasLineDiscount(li) {
        return Array.isArray(li?.line_level_discount_allocations) && li.line_level_discount_allocations.length > 0;
    }
    function isSubsLine(li) { return !!li?.selling_plan_allocation; }
    function isGiftLine(li) {
        return ((li?.product_type || '').toLowerCase() === 'gift') ||
            (li?.properties && li.properties['_lrcGift'] === '1');
    }

    // Per-line "compare-at" total (in cents)
    function computeLineCompareAtCents(li, subsQtyTotalT, unlockedPct=10) {
        const qty = Math.max(1, Number(li?.quantity) || 1);
        const unit1 = Math.max(0, Math.round(Number(li?.price) || 0));
        const unit2 = Math.max(0, Math.round(Number(li?.selling_plan_allocation?.compare_at_price) || 0));
        const base1 = Math.max(0, Math.round(Number(li?.price) || 0));
        const base2 = Math.max(0, Math.round(Number(li?.final_line_price) || 0));
        const discounted = hasLineDiscount(li);

        let original_reward_price_fc = Math.round(unit2 - (unit2 * (unlockedPct / 100)));
        let total_price_subs_fc = original_reward_price_fc * qty;

        if (isSubsLine(li)) {
            return discounted ? total_price_subs_fc : (unit2 * qty);
        } else {
            return discounted ? (unit1 * qty) : base2;
        }
    }

    // Robust per-line discount math (in cents)
    function computeLineDiscountCents(line, subsQtyTotal = 1, unlockedPct = 0, isMixedVariant = false) {
        if (!line) return 0;
        const allocs = Array.isArray(line.line_level_discount_allocations)
            ? line.line_level_discount_allocations
            : [];

        const hasDiscC = hasLineDiscount(line);    

        let lineTotal = 0;
        if (line?.selling_plan_allocation?.compare_at_price) {
            let line_cmt_priceC = line?.selling_plan_allocation?.compare_at_price;
            let line_subs_priceC = Math.round(line_cmt_priceC - (line_cmt_priceC * (unlockedPct / 100)));
            lineTotal = (line_subs_priceC * line?.quantity) || 0;
        } else {
            lineTotal = Number(line.final_line_price) || 0;
        }

        const qty = Number(line.quantity) || 1;
        let sum = 0;
        if(isMixedVariant && !!line?.selling_plan_allocation && hasDiscC){
            sum = line?.total_discount
        }else if(allocs?.length > 0){
            for (const alloc of allocs) {
                const app = alloc.discount_application || {};
                const valueType = String(app.value_type || app.type || '').toLowerCase();
                const valueNum = Number(app.value ?? app.percentage ?? 0) || 0;
                if (valueType.includes('percentage')) {
                    sum += Math.round(lineTotal * (valueNum / 100));
                } else if (valueType.includes('fixed_amount')) {
                    let shopify_discount = (Number(app.value) * 100) || 0;
                    sum += Math.round(shopify_discount - (shopify_discount * (unlockedPct / 100)));
                }
            }
        }
        else{
            sum = line?.total_discount
        }
        return sum;
    }

    function computeDiscountedLineTotalCents(subsQtyTotal = 1, line, unlockedPct=10, isMixedVariant = false) {
        let line_cmt_price = line?.selling_plan_allocation?.compare_at_price;
        let line_subs_price = Math.round(line_cmt_price - (line_cmt_price * (unlockedPct / 100)));
        //console.log("math-max", Math.round(line_subs_price));
        let original_reward_price = line_subs_price * line?.quantity;

        const dis = computeLineDiscountCents(line, subsQtyTotal, unlockedPct, isMixedVariant);
        //console.log("dis", dis);
        return (original_reward_price - dis);
    }

    const unlockedPctCall = window.lrcGetUnlockedTierPercent?.() || 0;

    async function updateFooterTotalsFromCache(cart, unlockedPct = 10) {
        const footer = document.querySelector('.border-t.border-cyan-200.px-4.py-4');
        if (!footer || !cart) return;

        const GIFT_TAG_2 = '_lrcGift';
        const isGiftLineT = (li) =>
            ((li?.product_type || '').toLowerCase() === 'gift') ||
            (li?.properties && li.properties[GIFT_TAG_2] === '1');

        // ✅ build mixed-mode map once
        const modeMap_2 = buildVariantModeMap(cart);    

        // Only true subscription lines (non-gift)
        const subsLinesT = (cart.items || []).filter(li => !!li.selling_plan_allocation && !isGiftLineT(li));
        let totalCartQty = cart.items.reduce((sum, li) => sum + (Number(li.quantity) || 0), 0);

        let totalCents = 0;
        let compareTotalCents = 0;

        for (const li of (cart.items || [])) {
            if (isGiftLine(li)) continue;

            const vid = Number(li?.variant_id);
            const mixed_2 = modeMap_2.get(vid)?.mixed === true;

            let base = 0;

            if (isSubsLine(li)) {
                const disc = Math.max(0, Math.round(computeLineDiscountCents(li, totalCartQty, unlockedPct, mixed_2) || 0));
                //console.log("disc", disc);
                let line_cmt_price_ftr = li?.selling_plan_allocation?.compare_at_price;
                let line_subs_price_ftr = Math.round(line_cmt_price_ftr - (line_cmt_price_ftr * (unlockedPct / 100)));
                let line_total_qty_price_ftr = line_subs_price_ftr * li?.quantity;
                totalCents += line_total_qty_price_ftr >= disc ? Math.max(0, line_total_qty_price_ftr - disc) : (line_total_qty_price_ftr - li?.total_discount);
            } else {
                totalCents += li?.final_line_price;
            }
            compareTotalCents += computeLineCompareAtCents(li, totalCartQty, unlockedPct);
        }

        const totals = footer.querySelectorAll('span.text-base.font-medium.text-cyan-700');
        const totalEl = totals[totals.length - 1];
        if (totalEl) totalEl.textContent = formatMoney(totalCents);

        const compareEl = footer.querySelector('[data-total-compare], .lrc-total-compare');
        //console.log("compareTotalCents", compareTotalCents);
        //console.log("totalCartQty", totalCartQty);
        const totalCentsDiacount = totalCents;
        if (compareEl) {
            if (compareTotalCents > totalCentsDiacount) {
                compareEl.textContent = formatMoney(compareTotalCents);
                compareEl.classList.remove('hidden');
            } else {
                compareEl.textContent = '';
                compareEl.classList.add('hidden');
            }
        }
    }

    function getCardByVariantId(variantId) { return document.querySelector(`.lrc-subscription-item-card[data-lrc-variant-id="${variantId}"]`); }
    function parseGroupsFromCard(card) {
        if (!card) return [];
        const raw = card.getAttribute('data-lrc-subs-selling-plan') || '[]';
        try { const ta = document.createElement('textarea'); ta.innerHTML = raw; const arr = JSON.parse(ta.value || '[]'); return Array.isArray(arr) ? arr : []; } catch { return []; }
    }
    function findGroupByExactName(groups, name) { if (!name) return null; const t = String(name).trim().toLowerCase(); return groups.find(g => String(g?.name || '').trim().toLowerCase() === t) || null; }
    function pickFirstPlanInGroup(group) { const plans = Array.isArray(group?.selling_plans) ? group.selling_plans : []; return plans.length ? plans[0] : null; }
    function allSellingPlansOnPage() {
        const out = []; document.querySelectorAll('.lrc-subscription-item-card').forEach(card => {
            const raw = card.getAttribute('data-lrc-subs-selling-plan') || '[]';
            try { const t = document.createElement('textarea'); t.innerHTML = raw; const groups = JSON.parse(t.value || '[]') || []; groups.forEach(g => (g?.selling_plans || []).forEach(sp => out.push(sp))); } catch { }
        }); return out;
    }
    const findPlanById = (id) => allSellingPlansOnPage().find(sp => String(sp?.id) === String(id)) || null;

    function getAdjustment(plan) {
        if (!plan) return null;
        if (Array.isArray(plan.price_adjustments) && plan.price_adjustments.length) { const a = plan.price_adjustments[0]; return { type: a.value_type, value: Number(a.value) || 0 }; }
        if (plan.discount_number != null) {
            const t = (plan.discount_type || 'percentage').toLowerCase();
            const type = t.includes('percent') ? 'percentage' : (t.includes('fixed') || t.includes('amount')) ? 'fixed_amount' : (t.includes('price') ? 'price' : 'percentage');
            return { type, value: Number(plan.discount_number) || 0 };
        }
        return null;
    }
    function applyAdjustment(unitCents, plan) { const adj = getAdjustment(plan); if (!adj) return unitCents; const v = Number(adj.value) || 0; if (adj.type === 'percentage') return Math.round(unitCents * (100 - v) / 100); if (adj.type === 'fixed_amount') return Math.max(0, Math.round(unitCents - v)); if (adj.type === 'price') return Math.round(v); return unitCents; }
    function unapplyAdjustment(unitCents, plan) { const adj = getAdjustment(plan); if (!adj) return unitCents; const v = Number(adj.value) || 0; if (adj.type === 'percentage') return Math.round(unitCents * 100 / Math.max(1, 100 - v)); if (adj.type === 'fixed_amount') return Math.round(unitCents + v); if (adj.type === 'price') return Math.round(v); return unitCents; }

    const readBaseUnits = () => readLS(LS_BASE_UNIT, {}); const writeBaseUnits = o => writeLS(LS_BASE_UNIT, o);
    function upsertBaseUnit(vid, c) { if (!Number.isFinite(c) || c <= 0) return; const map = readBaseUnits(); const prev = Number(map[vid]) || 0; if (!prev || c > prev) { map[vid] = c; writeBaseUnits(map); } }
    function resolveBaseUnitCents(li) {
        const qty = Math.max(1, Number(li.quantity) || 1);
        const cmpRaw = Number(li?.selling_plan_allocation?.compare_at_price) || 0;
        const observed = Math.round((Number(li.final_line_price) || Number(li.line_price) || 0) / qty) || 0;
        const cmpPerUnit = (cmpRaw && qty > 1 && cmpRaw > observed * 1.5) ? Math.round(cmpRaw / qty) : cmpRaw;
        //const candidates = [cmpPerUnit, Number(li?.original_price) || 0, Math.round((Number(li?.original_line_price) || 0) / qty) || 0, Number(li?.compare_at_price) || 0].filter(Boolean);
        const candidates = [
            Number(li?.original_price) || 0,
            Math.round((Number(li?.original_line_price) || 0) / qty) || 0,
            Number(li?.selling_plan_allocation?.compare_at_price) || 0
        ].filter(Boolean);
        if (candidates.length) return candidates.find(n => Number.isFinite(n) && n > 0) || 0;
        if (observed) { const plan = li.selling_plan_allocation?.selling_plan?.id ? findPlanById(li.selling_plan_allocation.selling_plan.id) : null; return plan ? unapplyAdjustment(observed, plan) : observed; }
        return 0;
    }
    async function hydrateBaseUnitsFromCartCache() { const cart = await getCartCached().catch(() => null); if (!cart) return; for (const li of (cart.items || [])) { const vid = Number(li.variant_id); if (!Number.isFinite(vid)) continue; const base = resolveBaseUnitCents(li); upsertBaseUnit(vid, base); } }

    function optimisticAddGiftsToCache(cart, ids, info) { if (!ids.length) return cart; const now = Date.now(); const existing = new Set((cart.items || []).map(li => Number(li.variant_id))); for (const id of ids) { if (existing.has(id)) continue; const inf = info[id] || {}; cart.items.push({ key: `tmpgift-${id}-${now}`, id, variant_id: id, product_type: 'Gift', properties: { [GIFT_TAG]: '1' }, quantity: 1, price: 0, line_price: 0, final_line_price: 0, image: inf.image || '', title: inf.title || 'Gift', url: inf.url || '#', selling_plan_allocation: null }); } return cart; }
    function optimisticRemoveGiftsFromCache(cart, ids) { if (!ids.length) return cart; cart.items = (cart.items || []).filter(li => { const isGift = (li.product_type || '').toLowerCase() === 'gift' || li.properties?.[GIFT_TAG] === '1'; if (!isGift) return true; return !ids.includes(Number(li.variant_id)); }); return cart; }

    function optimisticApplyPlanGroupToSubs(cart, groupNameOrId) {
        const baseMap = readBaseUnits();
        function choosePlanForLine(li) {
            const vid = Number(li.variant_id); if (!Number.isFinite(vid)) return null;
            const card = getCardByVariantId(vid);
            const groups = parseGroupsFromCard(card);
            if (groups.length && typeof groupNameOrId === 'string') { const grp = findGroupByExactName(groups, groupNameOrId) || groups[0]; const chosen = pickFirstPlanInGroup(grp); if (chosen) return chosen; }
            const byId = findPlanById(groupNameOrId); if (byId) return byId;
            if (groups.length) return pickFirstPlanInGroup(groups[0]); return null;
        }
        for (const li of (cart.items || [])) {
            if (!li?.selling_plan_allocation) continue;
            const vid = Number(li.variant_id); const qty = Math.max(1, Number(li.quantity) || 1);
            let base = Number(baseMap[vid]) || 0;
            if (!base) { base = resolveBaseUnitCents(li); upsertBaseUnit(vid, base); base = Number(readBaseUnits()[vid]) || base; }
            if (!base) continue;
            const chosen = choosePlanForLine(li); if (!chosen) continue;
            const newUnit = applyAdjustment(base, chosen); const newLine = Math.max(0, newUnit * qty);
            // li.selling_plan_allocation = { ...(li.selling_plan_allocation || {}), selling_plan: { ...(li.selling_plan_allocation?.selling_plan || {}), id: chosen.id, name: chosen.name }, compare_at_price: base };
            // li.price = base; li.line_price = newLine; li.final_line_price = newLine; li.__lrc_unit_price = newUnit; li.__lrc_discount_cents = Math.max(0, (base - newUnit) * qty);
            
            // only store helper values for UI
            li.selling_plan_allocation = {
                ...(li.selling_plan_allocation || {}),
                selling_plan: {
                    ...(li.selling_plan_allocation?.selling_plan || {}),
                    id: chosen.id,
                    name: chosen.name
                }
            };

            // UI-only helpers
            li.__lrc_unit_price = newUnit; // used by your UI unit price display
            li.__lrc_discount_cents = Math.max(0, (base - newUnit) * qty);
            li.__lrc_base_unit = base;
        }
        //cart.total_price = (cart.items || []).reduce((s, li) => s + (Number(li.final_line_price) || 0), 0); return cart;
    }

    // === render grid ===
    function renderGiftGridFromRewards(ids, infoByVariantId) {
        const grid = document.getElementById('lrc-free-gifts-grid'); if (!grid) return;

        // Build REAL gifts html
        const order = [...ids].reverse();
        const realHtml = order.map(id => {
            const inf = infoByVariantId[id] || {};
            const img = inf.image ? `<img src="${inf.image}" loading="lazy" class="w-full h-32 object-contain">` : '';
            const sub = inf.subtitle ? `<h6 class="font-base text-xs text-cyan-800 text-center">${inf.subtitle}</h6>` : '';
            return `<div class="flex flex-col space-y-2 group relative" data-lrc-gift-vid="${id}">
                <a href="${inf.url || '#'}">${img}</a>
                ${sub}
                <h5 class="font-base text-sm text-cyan-800 font-[700] text-center leading-[16px] tracking-tight">
                  <a href="${inf.url || '#'}">${inf.title || 'Gift'}</a>
                </h5>
              </div>`;
        }).join('');

        // VIRTUAL gifts html (subscription-only) and prepend
        let virtualFirst = '';
        try { virtualFirst = (window.lrcVirtualGifts && window.lrcVirtualGifts.htmlForUnlocked) ? window.lrcVirtualGifts.htmlForUnlocked() : ''; } catch { }

        grid.innerHTML = virtualFirst + realHtml;
    }

    async function reconcileOptimistic() {
        const { ids: desiredIds, infoByVariantId } = computeDesiredGiftsMap();
        const pending = readPending();

        const cart = await getCartCached().catch(() => ({ items: [], total_price: 0 }));
        const currentGiftVidSet = new Set((cart.items || [])
            .filter(li => (li.product_type || '').toLowerCase() === 'gift' || li.properties?.[GIFT_TAG] === '1')
            .map(li => Number(li.variant_id)).filter(Number.isFinite));

        const desiredSet = new Set(desiredIds);
        const toAdd = [...desiredSet].filter(id => !currentGiftVidSet.has(id));
        const toRemove = [...currentGiftVidSet].filter(id => !desiredSet.has(id));

        const nextPending = {
            addGiftIds: [...new Set([...(pending.addGiftIds || []), ...toAdd])],
            removeGiftIds: [...new Set([...(pending.removeGiftIds || []), ...toRemove])],
            planByVariantId: pending.planByVariantId || {}
        };
        writePending(nextPending);

        let nextCart = { ...(cart || {}), items: [...(cart.items || [])] };
        nextCart = optimisticAddGiftsToCache(nextCart, toAdd, infoByVariantId);
        nextCart = optimisticRemoveGiftsFromCache(nextCart, toRemove);
        writeCartCached(nextCart);

        renderGiftGridFromRewards(desiredIds, infoByVariantId);
        updateFooterTotalsFromCache(nextCart, unlockedPctCall);
        window.lrcRefreshSubsFromLatestCart();
    }

    const readPassMap = () => readLS(LS_PASS_PLAN_MAP, {});
    const writePassMap = o => writeLS(LS_PASS_PLAN_MAP, o);

    function getCurrentPass() { const root = document.getElementById('lrc-rewards-root'); return root ? (parseInt(root.getAttribute('data-lrc-qty') || '0', 10) || 0) : 0; }
    function hydratePassMapFromRewards() {
        const root = document.getElementById('lrc-rewards-root'); if (!root) return;
        const current = getCurrentPass();
        const rewards = parseEscapedJson(root.getAttribute('data-lrc-rewards') || '[]');
        const map = {};
        for (let p = 1; p <= current; p++) { const r = rewards.find(x => Number(x.id) === p); if (!r) continue; if ((r.reward_type || '').toLowerCase() === 'discount-reward') { const nm = String(r.subs_selling_plan_name || '').trim(); if (nm) map[String(p)] = nm; } }
        const left = rewards.find(x => Number(x.id) === current + 1);
        if (left?.reward_type === 'discount-reward') { const prev = rewards.find(x => Number(x.id) === current); const nmm = String(prev?.subs_selling_plan_name || '').trim(); if (nmm) map[String(current)] = nmm; }
        writePassMap(map);
    }
    function lastPlanAtOrBelow(pass) {
        const map = readPassMap();
        const keys = Object.keys(map).map(Number).filter(Number.isFinite).filter(k => k <= pass).sort((a, b) => b - a);
        return keys.length ? (map[String(keys[0])] || null) : null;
    }

    async function applyPlanForCurrentPassOptimistic() {
        const pass = getCurrentPass();
        const groupName = lastPlanAtOrBelow(pass); if (!groupName) return;
        const cart = await (getCartCached().catch(() => ({ items: [], total_price: 0 })));
        const next = optimisticApplyPlanGroupToSubs({ ...cart, items: [...(cart.items || [])] }, groupName);
        writeCartCached(next);

        const pending = readPending();
        (next.items || []).forEach(li => {
            if (!li?.selling_plan_allocation) return;
            const vid = Number(li.variant_id); const planId = li.selling_plan_allocation?.selling_plan?.id;
            if (Number.isFinite(vid) && planId) { pending.planByVariantId[String(vid)] = planId; }
        });
        writePending(pending);

        refreshSubsLineCardsFromCache(next);
        try { window.lrcHydrateConvertToSubs && window.lrcHydrateConvertToSubs(next); } catch { }
    }

    window.lrcRefreshSubsFromLatestCart = async function () {
        try {
            const cart = await getCartCached();
            if (cart) await refreshSubsLineCardsFromCache(cart);
        } catch (e) {
            console.warn('[LRC] lrcRefreshSubsFromLatestCart failed', e);
        }
    };

    async function refreshSubsLineCardsFromCache(cart) {
        console.log("cart", cart);
        const unlockedPct = window.lrcGetUnlockedTierPercent?.() || 0;

        const GIFT_TAG = '_lrcGift';
        const isGiftLine = (li) =>
            ((li?.product_type || '').toLowerCase() === 'gift') ||
            (li?.properties && li.properties[GIFT_TAG] === '1');
        
        // ✅ build mixed-mode map once
        const modeMap = buildVariantModeMap(cart);    

        // Only true subscription lines (non-gift)
        const subsLines = (cart.items || []).filter(li => !!li.selling_plan_allocation && !isGiftLine(li));
        // ---- NEW: total subscription quantity across all sub lines ----
        const subsQtyTotal = subsLines.reduce((sum, li) => sum + (Number(li.quantity) || 0), 0);

        const cards = Array.from(document.querySelectorAll('.lrc-subscription-item-card'));
        cards.forEach((card, idx) => {
            const line = subsLines[idx]; if (!line) return;

            const vid = Number(line?.variant_id);
            const mixed = modeMap.get(vid)?.mixed === true;

            const unitEl = card.querySelector('[data-unit-price], .lrc-unit-price');
            const qty = Math.max(1, Number(line.quantity) || 1);
            const hasDisc = Array.isArray(line.line_level_discount_allocations) && line.line_level_discount_allocations.length > 0;
            const currentLineCents = computeDiscountedLineTotalCents(subsQtyTotal, line, unlockedPct, mixed);
            const unit = Number(line.__lrc_unit_price) || Math.round((Number(line.final_line_price) || 0) / qty);
            if (unitEl) unitEl.textContent = formatMoney(unit);

            let line_cmt_price_m = line?.selling_plan_allocation?.compare_at_price;
            let line_subs_price_m = Math.round(line_cmt_price_m - (line_cmt_price_m * (unlockedPct / 100)));
            const compareLineCents = hasDisc ? ((line_subs_price_m * qty) || 0) : (Number(line_cmt_price_m * qty) || 0);    

            const compareLineEl = card.querySelector('[data-compare-at-total], .lrc-compare-at-total, .lrc-compare-at');
            const priceEl = card.querySelector('[data-line-total], h4.text-base.font-medium.text-cyan-600');
            if (priceEl) priceEl.textContent = formatMoney(computeDiscountedLineTotalCents(subsQtyTotal, line, unlockedPct, mixed));

            if (compareLineEl) {
                const show = compareLineCents > currentLineCents;
                compareLineEl.textContent = formatMoney(compareLineCents);
                compareLineEl.classList.toggle('hidden', !show);
            }

            const q = card.querySelector('[data-qty-value]'); if (q) q.textContent = line.quantity;
        });

        updateFooterTotalsFromCache(cart, unlockedPct);
    }


    // --- Fallback refresh hooks ---
    document.addEventListener('DOMContentLoaded', async () => {
        try {
            const cart = await getCartCached();
            if (cart) refreshSubsLineCardsFromCache(cart);
        } catch { }
    });

    document.addEventListener('lrc:drawer-updated', async () => {
        try {
            const cart = await getCartCached();
            if (cart) refreshSubsLineCardsFromCache(cart);
        } catch { }
    });

    /* ============================= Events ============================= */
    document.addEventListener('lrc:reward-unlocked', async (e) => {
        const type = (e?.detail?.reward_type || '').toLowerCase();
        if (type === 'discount-reward') {
            const planName = (e?.detail?.subs_selling_plan_name || '').trim();
            if (planName) { const pass = Number(e?.detail?.pass); const map = readPassMap(); map[String(pass)] = planName; writePassMap(map); }
        }
        await reconcileOptimistic();
        await applyPlanForCurrentPassOptimistic().catch(() => { });
        try { const cart = await getCartCached(); window.lrcHydrateConvertToSubs && window.lrcHydrateConvertToSubs(cart); } catch { }

        // Virtual gifts: only for subscriptions, and repaint/append for this pass
        try {
            const pass = Number(e?.detail?.pass || 0);
            if (pass && window.lrcVirtualGifts && window.lrcVirtualGifts.rebuildAll) {
                window.lrcVirtualGifts.removeForPass(pass);
                // Guarded inside appendForPass as well
                window.lrcVirtualGifts.appendForPass(pass);
            }
        } catch { }
    });

    document.addEventListener('lrc:reward-locked', async (e) => {
        await reconcileOptimistic();
        await applyPlanForCurrentPassOptimistic().catch(() => { });
        try { const cart = await getCartCached(); window.lrcHydrateConvertToSubs && window.lrcHydrateConvertToSubs(cart); } catch { }
        try {
            const pass = Number(e?.detail?.pass || 0);
            if (pass && window.lrcVirtualGifts) {
                window.lrcVirtualGifts.removeForPass(pass);
            }
        } catch { }
    });

    async function boot() {
        await hydrateBaseUnitsFromCartCache();
        hydratePassMapFromRewards();
        await reconcileOptimistic();
        await applyPlanForCurrentPassOptimistic();
        try { const cart = await getCartCached(); window.lrcHydrateConvertToSubs && window.lrcHydrateConvertToSubs(cart); } catch { }
        // Virtual gifts are rebuilt automatically on lrc:drawer-updated; nothing else to do here
    }

    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('lrc:drawer-updated', boot);

    /* ============================ Flush (real API) — checkout-time render sync ============================ */
    async function flushPendingOps() {
        const result = { ok: true, added: 0, removed: 0, planChanged: 0, finalCart: null };
        const PENDING_KEY = LS_PENDING;

        const readPending = () => { try { return JSON.parse(localStorage.getItem(PENDING_KEY) || '{}'); } catch { return {}; } };
        const writePending = (v) => { try { localStorage.setItem(PENDING_KEY, JSON.stringify(v)); } catch { } };
        const writeCartCached = (cart) => {
            if (window.lrcWriteCartCache) { try { window.lrcWriteCartCache(cart); return; } catch { } }
            try { localStorage.setItem(CART_CACHE_KEY, JSON.stringify({ t: Date.now(), cart })); } catch { }
        };
        const clearPending = () => writePending({ addGiftIds: [], removeGiftIds: [], planByVariantId: {} });

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));
        async function guardedFetch(url, opts, { tries = 3, baseDelay = 350 } = {}) {
            let attempt = 0;
            while (true) {
                try {
                    const r = await fetch(url, opts);
                    if (r.ok) return r;
                    if ((r.status === 429 || r.status >= 500) && attempt < tries - 1) {
                        attempt++; await sleep(baseDelay * attempt); continue;
                    }
                    return r;
                } catch (e) {
                    if (attempt < tries - 1) { attempt++; await sleep(baseDelay * attempt); continue; }
                    throw e;
                }
            }
        }
        async function runQueue(jobs, cc = 2) {
            const results = []; let idx = 0, active = 0;
            return await new Promise(resolve => {
                const next = () => {
                    if (idx >= jobs.length && active === 0) return resolve(results);
                    while (active < cc && idx < jobs.length) {
                        const my = idx++; active++;
                        jobs[my]().then(res => { results[my] = { ok: true, res }; }, err => { results[my] = { ok: false, err }; })
                            .finally(() => { active--; next(); });
                    }
                }; next();
            });
        }

        const getCart = async () => {
            const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
            if (!r.ok) throw new Error('cart fetch failed');
            const cart = await r.json();
            writeCartCached(cart);
            return cart;
        };

        // 1) Start with current pending (may include plan changes)
        const p = readPending();
        p.addGiftIds = Array.isArray(p.addGiftIds) ? p.addGiftIds : [];
        p.removeGiftIds = Array.isArray(p.removeGiftIds) ? p.removeGiftIds : [];
        p.planByVariantId = (p && typeof p.planByVariantId === 'object') ? p.planByVariantId : {};

        // 2) Fetch a fresh cart snapshot
        let cart; try { cart = await getCart(); } catch { cart = null; }

        // 3) Build quick indexes for the cart
        const lines = cart?.items || [];
        const giftByVariant = new Map();
        const subsLineByVariant = new Map(); // subscription lines only
        const oneLineByVariant  = new Map(); // one-time lines only

        function isGiftLineT(li) {
        return ((li.product_type || '').toLowerCase() === 'gift') || (li?.properties?.[GIFT_TAG] === '1');
        }

        lines.forEach((li, i) => {
        const vid = Number(li.variant_id);
        if (!Number.isFinite(vid)) return;

        const info = { index: i + 1, key: li.key, li };

        if (isGiftLineT(li)) {
            giftByVariant.set(vid, info);
        } else if (li?.selling_plan_allocation) {
            // subscription line
            if (!subsLineByVariant.has(vid)) subsLineByVariant.set(vid, info);
        } else {
            // one-time line
            if (!oneLineByVariant.has(vid)) oneLineByVariant.set(vid, info);
        }
        });


        // 4) Read REAL gift ids currently rendered in the grid (ignores virtuals)
        const desiredGiftIds = getRenderedGiftIdsFromGrid();
        const desiredSet = new Set(desiredGiftIds);

        // Compute add/remove strictly from the rendered grid
        const currentGiftIds = Array.from(giftByVariant.keys());
        const toAdd = desiredGiftIds.filter(id => !giftByVariant.has(id));
        const toRemove = currentGiftIds.filter(id => !desiredSet.has(id));

        // Overwrite pending gift ops with the render-truth for this flush
        p.addGiftIds = [...new Set(toAdd)];
        p.removeGiftIds = [...new Set(toRemove)];
        writePending(p);

        // If nothing to do at all (no gifts to add/remove AND no plan jobs), bail
        const hasPlanWork = p.planByVariantId && Object.keys(p.planByVariantId).length > 0;
        const hasGiftWork = (p.addGiftIds.length + p.removeGiftIds.length) > 0;
        if (!hasGiftWork && !hasPlanWork) return;

        // 5) Gifts: add the ones missing from cart
        const doAddGifts = async () => {
            if (!Array.isArray(p.addGiftIds) || !p.addGiftIds.length) return;
            const items = p.addGiftIds.map(id => ({ id, quantity: 1, properties: { [GIFT_TAG]: '1' } }));
            await guardedFetch('/cart/add.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items })
            }).catch(() => { });
            result.added = p.addGiftIds.length;
        };

        // 6) Gifts: remove any extra gifts not in the grid
        const removeGiftJobs = [];
        if (Array.isArray(p.removeGiftIds) && p.removeGiftIds.length) {
            p.removeGiftIds.forEach(vidNum => {
                const info = giftByVariant.get(Number(vidNum));
                if (!info) return;
                removeGiftJobs.push(() => guardedFetch('/cart/change.js', {
                    method: 'POST', credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: info.key, quantity: 0 })
                }).catch(() => { }));
            });
        }

        // 7) Plans: optional pending plan changes (change ONLY subscription lines)
        const planJobs = [];
        if (p.planByVariantId && typeof p.planByVariantId === 'object') {
        Object.entries(p.planByVariantId).forEach(([vidStr, planIdRaw]) => {
            const vid = Number(vidStr);
            const wantPlanId = planIdRaw === 'one-time' || planIdRaw == null ? null : planIdRaw;

            // We will ONLY ever touch a subscription line. Never convert a one-time line to subscription here.
            const subInfo = subsLineByVariant.get(vid);
            if (!subInfo) {
            // No subscription line for this variant → nothing to change.
            // This avoids turning a one-time line into a subscription line.
            return;
            }

            const currentPlanId = subInfo.li?.selling_plan_allocation?.selling_plan?.id || null;
            const sameAlready   = String(currentPlanId || '') === String(wantPlanId || '');

            if (sameAlready) return;

            // Build both "byIndex" and "byKey" payloads for robustness.
            const byIndex = {
            line: subInfo.index,
            quantity: subInfo.li.quantity,
            selling_plan: wantPlanId ? Number(wantPlanId) : null
            };
            const byKey = {
            id: subInfo.key,
            quantity: subInfo.li.quantity,
            selling_plan: wantPlanId ? Number(wantPlanId) : null
            };

            planJobs.push(async () => {
            // Try by index first
            const r = await guardedFetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(byIndex)
            });
            if (!r.ok) {
                // Fallback by key
                await guardedFetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(byKey)
                }).catch(() => { /* ignore */ });
            }
            result.planChanged++;
            });
        });
        }

        // 8) Execute: add gifts, then remove extras + plan jobs in parallel (limited)
        await doAddGifts().catch(() => { });
        const jobs = [...removeGiftJobs, ...planJobs];
        if (jobs.length) await runQueue(jobs, 2);
        result.removed = removeGiftJobs.length;

        // 9) Refresh cart, cache, clear pending
        let finalCart = null; try { finalCart = await getCart(); } catch { }
        result.finalCart = finalCart;
        if (finalCart) writeCartCached(finalCart);
        clearPending();
        console.log('[lrcFlushPendingOps] synced gifts to grid + applied plan jobs', result);
        return result;
    }
    window.lrcFlushPendingOps = flushPendingOps;

    function hasPendingWork() { const p = readPending(); return !!(p.addGiftIds.length || p.removeGiftIds.length || Object.keys(p.planByVariantId).length); }
})();

/** lrc-cart-gift-cleanup.js — unchanged **/
(function () {
    const PENDING_KEY = 'lrc-custom-pending-cart-ops'; const GIFT_TAG = '_lrcGift';
    function readPendingLS() { try { return JSON.parse(localStorage.getItem(PENDING_KEY) || '{}'); } catch { return {}; } }
    function hasPendingWorkLS() { const p = readPendingLS(); const a = Array.isArray(p.addGiftIds) ? p.addGiftIds.length : 0; const r = Array.isArray(p.removeGiftIds) ? p.removeGiftIds.length : 0; const pl = p && p.planByVariantId && typeof p.planByVariantId === 'object' ? Object.keys(p.planByVariantId).length : 0; return !!(a || r || pl); }
    async function removeAllGiftLines() {
        try {
            const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(r => r.json());
            const gifts = (cart.items || []).filter(li => ((li.product_type || '').toLowerCase() === 'gift') || (li?.properties?.[GIFT_TAG] === '1'));
            if (!gifts.length) return;
            for (const li of gifts) { try { await fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: li.key, quantity: 0 }) }); } catch { } }
            try { const fresh = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(r => r.json()); window.lrcWriteCartCache?.(fresh); } catch { }
            await window.lrcUpdateCartDrawer?.(null, { open: false, refreshHeader: true, syncRewards: true });
        } catch (e) { console.warn('[LRC] gift cleanup failed', e); }
    }
    function onReady() { if (!hasPendingWorkLS()) removeAllGiftLines(); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', onReady, { once: true }); } else { onReady(); }
})();

/** auto-clear cart when empty (unchanged) **/
(function () {
    const CART_CACHE_KEY = 'lrc-custom-get-cart'; const GIFT_TAG = '_lrcGift'; let _clearing = false;
    const readCache = () => { try { const raw = localStorage.getItem(CART_CACHE_KEY); if (!raw) return null; const obj = JSON.parse(raw); return obj && obj.cart ? obj.cart : null; } catch { return null; } };
    const writeCache = (cart) => { if (window.lrcWriteCartCache) { try { window.lrcWriteCartCache(cart); return; } catch { } } try { localStorage.setItem(CART_CACHE_KEY, JSON.stringify({ t: Date.now(), cart })); } catch { } };
    const isGiftLine = li => ((li.product_type || '').toLowerCase() === 'gift') || (li?.properties?.[GIFT_TAG] === '1');
    const isSubsLine = li => !!li?.selling_plan_allocation;
    const isOneTimeLine = li => !isGiftLine(li) && !isSubsLine(li);
    async function fetchCart() { const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }); const cart = await r.json(); writeCache(cart); return cart; }
    function summarize(cart) { const items = Array.isArray(cart?.items) ? cart.items : []; let subs = 0, one = 0; for (const li of items) { if (isGiftLine(li)) continue; if (isSubsLine(li)) subs += (Number(li.quantity) || 0); else one += (Number(li.quantity) || 0); } return { subs, one }; }
    async function clearCartAndRefresh() { if (_clearing) return; _clearing = true; try { await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } }); const fresh = await fetchCart().catch(() => null); try { await window.lrcUpdateCartDrawer?.(null, { open: false, refreshHeader: true, syncRewards: true }); if (fresh) { window.lrcHydrateConvertToSubs && window.lrcHydrateConvertToSubs(fresh); } } catch { } } finally { _clearing = false; } }
    async function checkAndMaybeClearCart({ forceServerCheck = false } = {}) { try { let cart = readCache(); if (!cart || forceServerCheck) { cart = await fetchCart(); } const { subs, one } = summarize(cart); if (subs === 0 && one === 0) { await clearCartAndRefresh(); } } catch (e) { console.warn('[LRC] auto-clear check failed', e); } }
    document.addEventListener('DOMContentLoaded', () => { checkAndMaybeClearCart(); }, { once: true });
    document.addEventListener('lrc:drawer-updated', () => { checkAndMaybeClearCart(); });
    document.addEventListener('click', (ev) => { const overlay = ev.target.closest('[data-lrc-cart-overlay]'); const closeBtn = ev.target.closest('[data-lrc-cart-close]'); if (overlay || closeBtn) { checkAndMaybeClearCart({ forceServerCheck: true }); } });
})();
